import React, { Component, Fragment } from "react";
import RcTooltip from "rc-tooltip";
import Classnames from "classnames";
import { observer } from "mobx-react";
import PropTypes from "prop-types";
import Swiper from "swiper";

import "@/assets/css/swiper.css";
import { MAP_HERO_EN_CN, MAP_SERVER_EN_CN } from "@/utils/getting";
import { GetQueryParam, SetQueryParam } from "@/utils/setting";
import Store from "@/stores";

class MemuTips extends Component {
	static propTypes = {
		classSlug: PropTypes.string,
		hardcore: PropTypes.bool,
		level: PropTypes.number,
		name: PropTypes.string,
		seasonal: PropTypes.bool
	}
	static defaultProps = {
		classSlug: "",
		hardcore: false,
		level: 0,
		name: "",
		seasonal: false
	}
	render() {
		const { classSlug, hardcore, level, name, seasonal } = this.props;
		return (
			<Fragment>
				<h3>{name}</h3>
				<p className={hardcore ? "hand" : ""}>
					{level}级{MAP_HERO_EN_CN[classSlug]}
					{seasonal && <span> -赛季英雄</span>}
				</p>
				{hardcore && <p className={hardcore ? "hand" : ""}>专家模式</p>}
			</Fragment>
		);
	}
}

class MenuItem extends Component {
	static propTypes = {
		active: PropTypes.bool,
		classSlug: PropTypes.string,
		gender: PropTypes.number,
		hardcore: PropTypes.bool,
		level: PropTypes.number,
		name: PropTypes.string,
		seasonal: PropTypes.bool,
		select: PropTypes.func
	}
	static defaultProps = {
		active: false,
		classSlug: "unknow",
		gender: 0,
		hardcore: false,
		level: 0,
		name: "",
		seasonal: false,
		select: null
	}
	render() {
		const { active, classSlug, gender, hardcore, level, name, seasonal, select } = this.props;
		const hero = classSlug + (gender === 1 ? "-w" : "-m");
		return (
			<RcTooltip
				destroyTooltipOnHide={true}
				overlay={<MemuTips {...this.props} />}
				overlayClassName="ladder-menu-tips"
				placement="topLeft"
			>
				<div className={Classnames(`${hero} swiper-slide tran-fast`, { active })} onClick={select}>
					<p>
						<em className={hardcore ? "hand" : ""}>{level}</em>
						<span className="ellipsis">{name}</span>
					</p>
					{seasonal && <i />}
				</div>
			</RcTooltip>
		);
	}
}

@observer
class Menu extends Component {
	state = { index: 0 }
	componentDidMount() {
		const hero = GetQueryParam("hero");
		const { heroes } = Store._ladderStore.target;
		const index = heroes.findIndex(v => v.id === +hero);
		this.setState({ index: index > -1 ? index : 0 });
		this.swiper = new Swiper(".swiper-container", {
			initialSlide: index > -1 ? index : 0,
			navigation: {
				nextEl: ".next-btn",
				prevEl: ".prev-btn"
			},
			observeParents: true,
			observer: true,
			observeSlideChildren: true,
			preloadImages: false,
			slidesPerView: 10,
			spaceBetween: 6,
			speed: 500
		});
	}
	render() {
		const { getHero, hero, target } = Store._ladderStore;
		const { battleTag, guildName, heroes } = target;
		const { class: classes, server } = hero || {};
		const { index } = this.state;
		const list = heroes.map((v, i) => {
			const obj = Object.assign({}, v, {
				active: i === index,
				select: () => {
					if (i === index) return;
					this.setState({ index: i });
					this.swiper.slideTo(i, 500);
					SetQueryParam({ hero: v.id });
					const { btag, hero, server } = GetQueryParam();
					getHero(btag, hero, server);
				}
			});
			return <MenuItem key={v.id} {...obj} />;
		});
		return (
			<div className="ladder-menu">
				<h1>{battleTag}{guildName && <span> &lt;{guildName}&gt;</span>}</h1>
				<h2>{MAP_SERVER_EN_CN[server || "cn"]} | {MAP_HERO_EN_CN[classes || ""] || "无数据"}</h2>
				<div className="menu pr">
					<div className="swiper-container center">
						<div className="swiper-wrapper">{list}</div>
					</div>
					<div className="prev-btn"></div>
					<div className="next-btn"></div>
				</div>
			</div>
		);
	}
}
export default Menu;